import React, {useContext} from "react"
import {Panel, DataRow} from "../../PDFPrimitives"
import {PDFContext} from "../../BasePDF"

export const PurchaseCustomerPriceBreakdownPDF = () => {
    const pdfData = useContext(PDFContext)
    if (!pdfData) return null

    // NJ only; Sales Tax doesn't include it.
    const supplementalTitleFee = pdfData.supplemental_title_fee

    return (
        <Panel title="Price Breakdown">
            <DataRow label="Selling Price"           value={pdfData.selling_price.toDollarFormat()}/>
            <DataRow label="Sales Tax"               value={pdfData.total_taxes.toDollarFormat()}/>
            {supplementalTitleFee && (
                <DataRow label={supplementalTitleFee.name} value={supplementalTitleFee.amount.toDollarFormat()}/>
            )}
            <DataRow label="Customer Rebate (Disc)"  value={pdfData.total_rebates.toDollarFormat()} variant="green"/>
            <DataRow label="Fees"                    value={pdfData.total_fees.toDollarFormat()} isLast/>
        </Panel>
    )
}
